"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
var errorMessage_1 = require("./errorMessage");
Object.defineProperty(exports, "ErrorMessage", { enumerable: true, get: function () { return __importDefault(errorMessage_1).default; } });
//# sourceMappingURL=index.js.map